import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '../components/common/LoadingSpinner.jsx';
import { useAuth } from '../hooks/useAuth.js';

export const StartupPage = () => {
  const navigate = useNavigate();
  const { checkAuth, isAuthenticated, isLoading, isInitialized } = useAuth();

  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log('[StartupPage] Checking authentication state...');
        await checkAuth();
      } catch (error) {
        console.error('[StartupPage] Auth check failed:', error);
      }
    };

    initializeApp();
  }, [checkAuth]);

  // Redirect once initialization is complete
  useEffect(() => {
    if (isInitialized && !isLoading) {
      if (isAuthenticated) {
        console.log('[StartupPage] User authenticated — redirecting to home');
        navigate('/home');
      } else {
        console.log('[StartupPage] User not authenticated — redirecting to login');
        navigate('/login');
      }
    }
  }, [isInitialized, isLoading, isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          mb: 2,
          textAlign: 'center',
        }}
      >
        Karobar POS
      </Typography>
      <Typography
        variant="h6"
        sx={{
          mb: 4,
          textAlign: 'center',
          opacity: 0.8,
        }}
      >
        Restaurant Management System
      </Typography>
      <LoadingSpinner
        size={60}
        message="Initializing..."
        color="inherit"
      />
    </Box>
  );
};
